__turbopack_context__.v({
  "btn": "style-module-scss-module__TOsfUW__btn",
  "extra": "style-module-scss-module__TOsfUW__extra",
  "link": "style-module-scss-module__TOsfUW__link",
  "link_border_right": "style-module-scss-module__TOsfUW__link_border_right",
  "link_gradientGold": "style-module-scss-module__TOsfUW__link_gradientGold",
  "link_gradientPurple": "style-module-scss-module__TOsfUW__link_gradientPurple",
  "list": "style-module-scss-module__TOsfUW__list",
  "nav": "style-module-scss-module__TOsfUW__nav",
  "rapper": "style-module-scss-module__TOsfUW__rapper",
  "tooltip": "style-module-scss-module__TOsfUW__tooltip",
  "wrapper": "style-module-scss-module__TOsfUW__wrapper",
  "wrapper_active": "style-module-scss-module__TOsfUW__wrapper_active",
});
